import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = ["id", "data-bs-target"]

import { EModal } from '@/enums';
import useModals from './useModals';


export default /*@__PURE__*/_defineComponent({
  __name: 'PWAInstallModal',
  setup(__props) {

const id = EModal.pwa_install;
const { toggleModal } = useModals();

const handleClose = () => {
  toggleModal(id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "modal fade",
      tabindex: "-1",
      id: _unref(id),
      "data-bs-backdrop": "false",
      "aria-labelledby": "pwaInstallModalLabel",
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", {
        class: "custom-backdrop",
        onClick: handleClose
      }),
      _createElementVNode("div", { class: "modal-dialog modal-dialog-centered" }, [
        _createElementVNode("div", { class: "modal-content border shadow-lg" }, [
          _createElementVNode("div", { class: "modal-header" }, [
            _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "h2 mb-0" }, "Instalar Greezon", -1)),
            _createElementVNode("i", {
              type: "button",
              class: "fas fa-times text-muted",
              "data-bs-dismiss": "modal",
              "aria-label": "Close",
              onClick: handleClose
            })
          ]),
          _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"modal-body border-0\" data-v-305aeae2><p class=\"mb-3\" data-v-305aeae2>Para instalar o Greezon na tela inicial do seu iPhone/iPad:</p><ol class=\"install-steps\" data-v-305aeae2><li class=\"mb-3\" data-v-305aeae2><i class=\"fas fa-share fs-5 me-2\" data-v-305aeae2></i> Toque no ícone de <strong data-v-305aeae2>compartilhar</strong> (quadrado com seta para cima) na barra inferior do Safari </li><li class=\"mb-3\" data-v-305aeae2><i class=\"fas fa-plus-square fs-5 me-2\" data-v-305aeae2></i> Role para baixo e toque em <strong data-v-305aeae2>&quot;Adicionar à Tela de Início&quot;</strong></li><li data-v-305aeae2><i class=\"fas fa-check-circle fs-5 me-2\" data-v-305aeae2></i> Toque em <strong data-v-305aeae2>&quot;Adicionar&quot;</strong> no canto superior direito </li></ol><p class=\"text-muted mt-3 mb-0\" data-v-305aeae2><small data-v-305aeae2>Após instalado, você poderá abrir o Greezon diretamente da tela inicial como um aplicativo.</small></p></div>", 1)),
          _createElementVNode("div", { class: "modal-footer" }, [
            _createElementVNode("button", {
              onClick: handleClose,
              class: "btn btn-dark btn-sm",
              "data-bs-dismiss": "modal"
            }, "Entendi")
          ])
        ])
      ])
    ], 8, _hoisted_1),
    _createElementVNode("button", {
      hidden: "",
      id: `trigger-${_unref(id)}-btn`,
      type: "button",
      "data-bs-toggle": "modal",
      "data-bs-target": `#${_unref(id)}`
    }, null, 8, _hoisted_2)
  ], 64))
}
}

})